import React from "react";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "@/components/common/Link";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function PageHeaderContent() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center space-y-6 animate-pulse w-full">
        <div className="h-4 w-32 bg-muted rounded-md" />
        <div className="h-12 w-3/4 md:w-1/2 lg:w-1/3 bg-muted rounded-md" />
      </div>
    );
  }

  if (error || !links || links.length === 0) {
    return null;
  }

  const currentParams = links[links.length - 1];
  const title = currentParams.title;

  return (
    <div className="flex flex-col items-center text-center space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700 fill-mode-both">
      <Breadcrumb>
        <BreadcrumbList className="justify-center">
          {links.map((link, index) => {
            const isLast = index === links.length - 1;
            return (
              <React.Fragment key={link.href}>
                <BreadcrumbItem data-index={index}>
                  {isLast ? (
                    <BreadcrumbPage className="font-medium text-foreground">
                      {link.title}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link
                        to={link.href}
                        className="transition-colors hover:text-primary"
                      >
                        {link.title}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {!isLast && <BreadcrumbSeparator />}
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary max-w-4xl">
        {title}
      </h1>
    </div>
  );
}

export default function PageTitleAndBreadcrumbs() {
  return (
    <section
      id="page-title-and-breadcrumbs"
      className="bg-background py-16 md:py-24 border-b border-border/40"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <ShopBreadcrumbsProvider>
          <PageHeaderContent />
        </ShopBreadcrumbsProvider>
      </div>
    </section>
  );
}